import React from 'react'
import BuilderPreviewComponent from "./BuilderPreviewComponent";

const BuilderPreviewComponentList = ({componentList}) => {
  return (
    <>
        {componentList && componentList.map((item,index) => {
            return(
                <BuilderPreviewComponent key={index} component={item} />
            )
        })}
    </>
  )
}

export default BuilderPreviewComponentList